<template>
    <div>
        <v-expansion-panels
            v-model="panel"
            multiple
        >
            <accordion-item
                v-for="(product, idx) in products"
                :key="idx"
                :calculationIdx="calculationIdx"
                :treatmentIdx="treatmentIdx"
                :drugIdx="drugIdx"
                :product="product"
                :selectedAttributes="selectedAttributes"
                @change-drug-state="changeDrugState"
                @mutate-drug="mutateDrug"
            ></accordion-item>
        </v-expansion-panels>
        <div class="px-2 py-2" v-if="selectedDrugs.length > 0">
            <span class="d-block text-caption text-underline">{{ drugTypeName }} T{{treatmentIdx}}:</span>
            <span class="d-block text-caption font-italic">{{ $t('targetBudget') }}: {{ formatPrice(budget) }} {{ currency.symbol }} / га</span>
            <span class="d-block text-caption font-italic">{{ $t('actualBudget') }} ({{productsString}}): {{ formatPrice(pricePerValueSum) }} {{ currency.symbol }} / га</span>
            <span class="d-block text-caption font-italic" :class="savingClass">{{ savingTitle }} {{ formatPrice(Math.abs(difference)) }} {{ currency.symbol }} / га {{ $t('or') }} {{ Math.abs(differenceInPercent).toFixed(2)}}&percnt;</span>
        </div>
    </div>
</template>

<script>
import AccordionItem from "./AccordionItem";
import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";
import numberFormat from "../../../../utils/numberFormat";

export default {
    name: "CategoryAccordion",
    components: { AccordionItem },
    mixins: [ CalculatorDataProvider ],
    props: [ 'products', 'calculationIdx', 'treatmentIdx', 'drugIdx', 'cultures', 'categories', 'attributes' ],
    data() {
        return {
            selectedDrugs: [],
            panel: []
        }
    },
    computed: {
        calculationDrugData() {
            return this.calculatorFullData[this.calculationIdx].treatments[this.treatmentIdx][this.drugIdx] || {};
        },
        budget() {
            return this.calculationDrugData.budget ? this.calculationDrugData.budget : 0
        },
        drugTypeName() {
            const categoryId =  this.calculationDrugData.filters.category[0];
            const category = this.categories.find(item => item.id === categoryId);
            return category ? category.localName : '---'

        },
        currency() {
            return this.$store.getters.currencies.find(item=>item.name === this.$store.getters.appCurrency);
        },
        productsString() {
            if (this.selectedDrugs.length === 1) {
                const idx = this.selectedDrugs.findIndex(item=>item.id !== undefined)
                return this.selectedDrugs[idx].productName;
            } else {
                return this.$t('selectedDrugs').toLowerCase();
            }
        },
        pricePerValueSum() {
            return this.selectedDrugs.reduce((sum, item)=>{
                return isNaN(item.pricePerValue) ? sum + 0 : sum + item.pricePerValue;
            }, 0)
        },
        selectedAttributes() {
            const categoryId = this.calculationDrugData.filters.category[0]
            let attributes = this.attributes.find(item => item.categoryID === categoryId)
            const selectedAttributes = []
            if (attributes) {
                for (const [filterName, selectedAttributeIDs] of Object.entries(this.calculationDrugData.filters)) {
                    const attribute = attributes.filters.find(item => item.systemName === filterName);
                    const selectedAttributeValues = [];
                    if(attribute) {
                        selectedAttributeIDs.forEach(id => {
                            const value = attribute.valuesData.find(item => item.id === id);
                            if(value) {
                                selectedAttributeValues.push(value)
                            }
                        });
                        selectedAttributes.push({
                            attributeSystemName: attribute.attributeSystemName,
                            label: attribute.label,
                            systemName: attribute.systemName,
                            valuesData: selectedAttributeValues
                        })
                    }
                }
            }
            return selectedAttributes
        },
        savingClass() {
            return this.difference > 0 ? 'teal--text' : 'red--text';
        },
        savingTitle() {
            return this.difference > 0 ? this.$t('saving') : this.$t('overprice');
        },
        difference() {
            return this.budget - this.pricePerValueSum;
        },
        differenceInPercent() {
            return this.difference / this.budget * 100;
        },
    },
    methods: {
        changeDrugState(data) {
            if(data.state) {
                this.selectedDrugs.push(data.basketDrug)
            } else {
                const idx = this.selectedDrugs.findIndex(item => item.id === data.basketDrug.id);
                if (idx >= 0) {
                    this.selectedDrugs.splice(idx, 1);
                }
            }
        },
        mutateDrug(data) {
            const idx = this.selectedDrugs.findIndex(item => item.id === data.id);
            if(idx >= 0) {
                this.$set(this.selectedDrugs, idx, data);
            }
        },
        formatPrice(sum) {
            return numberFormat(sum, 2, '.', ' ');
        }
    },
    created() {
    },
    watch: {
        selectedDrugs(value) {
            this.$emit('send-to-tab-result', {
                budget: this.budget,
                selectedDrugs: value
            });
        },
    }
}
</script>

<style scoped>

</style>
